import { useRouter } from "next/router";
import { useMemo, useEffect, useRef } from "react";

import CollectionFilter from "./CollectionFilter";
import { ALL_PRODUCTS_OBJECT } from "./Home/CollectionHome";

const StoreCollections = ({ collections, setFilter, selectedCollection, theme }) => {
  const router = useRouter();
  const collectionRefs = useRef({});

  const storeCollections = useMemo(() => {
    const list = [];

    // Add "All Products" pill with ref
    list.push(
      <div
        key="initial"
        ref={(el) => {
          collectionRefs.current["all-products"] = el;
        }}
      >
        <CollectionFilter
          collection={ALL_PRODUCTS_OBJECT}
          selectedCollection={selectedCollection}
          setFilter={setFilter}
          theme={theme}
        />
      </div>,
    );

    // Add collection pills with refs
    const collectionList = collections.map((collection) => (
      <div
        key={collection._id}
        ref={(el) => {
          collectionRefs.current[collection.name?.toLowerCase()] = el;
        }}
      >
        <CollectionFilter
          collection={collection}
          selectedCollection={selectedCollection}
          setFilter={setFilter}
          theme={theme}
        />
      </div>
    ));

    return list.concat(collectionList);
  }, [collections, selectedCollection, setFilter]);

  // Handle scroll to active collection on URL change
  useEffect(() => {
    const { collection: collectionParam } = router.query;

    if (collectionParam) {
      const targetKey = collectionParam.toLowerCase();
      const targetRef = collectionRefs.current[targetKey];

      if (targetRef) {
        setTimeout(() => {
          targetRef.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",
          });
        }, 100);
      }
    }
  }, []);

  return collections.length ? storeCollections : null;
};

export default StoreCollections;
